import { render } from "./OpeningBalance2.vue?vue&type=template&id=4804ed14&scoped=true"
import script from "./OpeningBalance2.vue?vue&type=script&lang=js"
export * from "./OpeningBalance2.vue?vue&type=script&lang=js"

import "./OpeningBalance2.vue?vue&type=style&index=0&id=4804ed14&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4804ed14"]])

export default __exports__